import type { User } from '@/types/shared';

let cachedUser: Partial<User> | null = null;
let lastUserString: string | null = null;

export function getCachedUser(): Partial<User> {
  try {
    const userString = localStorage.getItem('user');

    if (userString === lastUserString) {
      return cachedUser ?? {};
    }

    lastUserString = userString;
    cachedUser = userString ? (JSON.parse(userString) as Partial<User>) : {};
    return cachedUser;
  } catch {
    return {};
  }
}

export function invalidateUserCache() {
  lastUserString = null;
  cachedUser = null;
}
